export const mapCrumbsToStaticCrumbs = (crumbs) => {
  return crumbs.map((crumb) => {
    return {
      label: crumb.label,
      url: crumb.path || '',
    };
  });
};
